import { useTranslation } from 'react-i18next';
import { Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconClock } from '@tabler/icons-react';
import CarrierAssignSummary from '@/components/app/deals/steps/CarrierAssignSummary';
import type { BargainStepsInfo } from '@/types/deals';

interface CarrierAssignStepProps {
  readonly info: BargainStepsInfo;
}

// Шаг «Назначение перевозчика» (id 15) — между «Поручением экспедитора» и «Перевозкой».
//
// Два состояния. Пока перевозчика нет — говорим, что происходит и чем это закончится: раньше это
// ожидание было невидимым, сделка показывала «Перевозку», хотя заявка ещё лежала на бирже. Как только
// перевозчик взял заявку — показываем его самого, хронологию и подписанный им документ, а пока шаг ещё
// текущий (CARRIER_ASSIGNED), — и чего сделка ждёт дальше: перевозка начинается с первого дня погрузки.
//
// Отказ перевозчика возвращает заявку на биржу. Строкой факта объясняем возврат в ожидание: без неё шаг
// выглядел бы откатом сделки назад, то есть сбоем. Красного состояния не вводим — для сделки это не авария.
export default function CarrierAssignStep({ info }: CarrierAssignStepProps) {
  const { t } = useTranslation();
  const assigned = Boolean(info.carrierAssignedAt);

  if (assigned) {
    return (
      <Stack gap="md">
        {info.processingStep === 'CARRIER_ASSIGNED' ? (
          <Group gap="xs" wrap="nowrap" align="flex-start">
            <ThemeIcon size={32} radius="xl" variant="light" color="brand">
              <IconClock size={18} />
            </ThemeIcon>
            <Text fz="sm">{t('app.deals.carrierAssign.awaitingLoading')}</Text>
          </Group>
        ) : null}
        <CarrierAssignSummary info={info} />
      </Stack>
    );
  }

  return (
    <Stack gap="md">
      <Group gap="xs" wrap="nowrap" align="flex-start">
        <ThemeIcon size={32} radius="xl" variant="light" color="brand">
          <IconClock size={18} />
        </ThemeIcon>
        <Text fz="sm">{t('app.deals.carrierAssign.searching')}</Text>
      </Group>
      {info.carrierDeclinedAt ? (
        <Text fz="sm" c="gray.8">
          {t('app.deals.carrierAssign.declined', { date: info.carrierDeclinedAt })}
        </Text>
      ) : null}
    </Stack>
  );
}
